import React from "react";
import { Box, Button } from "@mui/material";
import { productCondition, unitCode } from "../../../common/models/CommonModels";
import { StockItemSupplier } from "../../shared/models/customerBuyerStockItemsModels";
import colors from "../../../shared/themes/colors";
import Location from "../../../shared/components/Location";
import OverflowTooltip from "../../../shared/components/OverflowTooltip";
import Distance from "../../../shared/components/Distance";
import CompanyLogo from "../../sentOffers/components/create/details/CompanyLogo";
import PriceRangeFormat from "../../../shared/components/formats/PriceRangeFormat";
import Chips from "../../../shared/components/chips/Chips";
import useTranslation from "../../../shared/hooks/useTranslation";

export interface ProductSupplierCardProps {
  supplier: StockItemSupplier;
  active?: boolean;
  onSelect?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ProductSupplierCard = ({ supplier, active = false, onSelect }: ProductSupplierCardProps) => {
  const { translate } = useTranslation("common");
  return (
    <Box
      className="w-full flex justify-between active"
      sx={{
        border: `1px solid ${colors.secondary.gray90}`,
        minHeight: "146px",
        borderRadius: "8px",
        padding: "16px",
        "&:hover": { background: colors.primary.blue3 },
        "&.active": { background: active ? colors.primary.blue3 : "" }
      }}
    >
      <Box className="flex">
        <CompanyLogo src={supplier.logo?.content} size={78} />

        <Box className="h-fill ml-2">
          <OverflowTooltip text={supplier.name} className="text-18-bold" color={colors.secondary.gray20} />
          <Location
            countryCode={supplier.countryId}
            textClassName="text-14-regular"
            textColor={colors.secondary.gray40}
            flagSize="medium"
            flagRounded={true}
          />
          <Distance distance={supplier.distance} size="medium" />
        </Box>
      </Box>

      <Box className="flex gap-4">

        <Box className="flex flex-col items-end justify-between" sx={{ minWidth: "147px" }}>
          <Box className="flex flex-col items-end">
            <PriceRangeFormat
              className="text-14-bold mb-2"
              color={colors.secondary.gray20}
              minValue={supplier?.minPrice}
              maxValue={supplier?.maxPrice}
            />

            <Chips value={supplier.conditionCodes?.map(code => translate(`productCondition.${productCondition(code)}`))} />
          </Box>

          <Box className="text-14-regular mt-2">{supplier?.quantity.value} {translate(`measurementUnits.${unitCode(supplier?.quantity.unitCode)}`)}</Box>

          <Button variant="text" className="text-14-medium" onClick={(ev) => onSelect?.(ev)}>
            {translate("showMore")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductSupplierCard;
